export default __webpack_public_path__ + "static/hero-bg-1d32ab1147e1d6181c1cc49921ead957.png";